module.exports = __webpack_public_path__ + "assets/images/pages/creando/creando-2.png?c9bbb4fc";